import { render } from "./Bills.vue?vue&type=template&id=9ab1a1fe&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"

import "./Bills.vue?vue&type=style&index=0&id=9ab1a1fe&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab1a1fe"]])

export default __exports__